import type { CarOptionSet } from "@/types/database";

export type OptionSetFormState = {
  make: string;
  models: string;
  trims: string;
};

export function parseOptionSetList(value: string): string[] {
  return value
    .split(/[\n,]+/)
    .map((item) => item.trim())
    .filter(Boolean);
}

export function optionSetListToText(items: string[] | null | undefined): string {
  return (items ?? []).join("\n");
}

export function defaultOptionSetForm(): OptionSetFormState {
  return { make: "", models: "", trims: "" };
}

export function optionSetToForm(optionSet: CarOptionSet): OptionSetFormState {
  return {
    make: optionSet.make,
    models: optionSetListToText(optionSet.models),
    trims: optionSetListToText(optionSet.trims),
  };
}
